// extracted by mini-css-extract-plugin
export default {"scope":"tW-AG","variants":"SPglO","primary":"_7WHxP","secondary":"Ai7Rq","locked-message":"rZB1C","c-ui-button":"ivGqV"};